<template>
  <div class="page" :style="`width:${dispW}px; height:${dispH}px;color:white;`">
    <el-container style="line-height: 0px">
      <el-main :height="`${dispH}px`" style="padding-left: 0px">
        <el-row>
          <el-col :span="8">
            <MapForm
              :isSelectVisibleBoolen="false"
              parentForm="fourierAnalysis"
              :indexInForm="0"
              :dispW="dispW / 3"
              :dispH="dispH / 2 - 70"
              :colorBarWidth="90"
              :mapValues="mapValues"
              :forcedTitle="$t('langcfg.txtSphericalComponent')"
            ></MapForm>
            <div style="border: 0.2px solid gray; height: 50px">
              <FourierParams :params="paramsSph"></FourierParams>
            </div>
          </el-col>
          <el-col :span="8">
            <MapForm
              :isSelectVisibleBoolen="false"
              parentForm="fourierAnalysis"
              :indexInForm="1"
              :dispW="dispW / 3"
              :dispH="dispH / 2 - 70"
              :colorBarWidth="90"
              :mapValues="mapValues"
              :forcedTitle="$t('langcfg.txtDecentration')"
            ></MapForm>
            <div style="border: 0.2px solid gray; height: 50px">
              <FourierParams :params="paramsDecent"></FourierParams>
            </div>
          </el-col>
          <el-col :span="8">
            <MapForm
              :isSelectVisibleBoolen="false"
              parentForm="fourierAnalysis"
              :indexInForm="2"
              :dispW="dispW / 3"
              :dispH="dispH / 2 - 30"
              :colorBarWidth="90"
              :mapValues="mapValues"
            ></MapForm>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <MapForm
              :isSelectVisibleBoolen="false"
              :indexInForm="3"
              parentForm="fourierAnalysis"
              :dispW="dispW / 3"
              :dispH="dispH / 2 - 70"
              :colorBarWidth="90"
              :mapValues="mapValues"
              :forcedTitle="$t('langcfg.txtRegularAstigmatism')"
            ></MapForm>
            <div style="border: 0.2px solid gray; height: 50px">
              <FourierParams :params="paramsRegular"></FourierParams>
            </div>
          </el-col>
          <el-col :span="8">
            <MapForm
              :isSelectVisibleBoolen="false"
              parentForm="fourierAnalysis"
              :indexInForm="4"
              :dispW="dispW / 3"
              :dispH="dispH / 2 - 70"
              :colorBarWidth="90"
              :mapValues="mapValues"
              :forcedTitle="$t('langcfg.txtIrregularity')"
            ></MapForm>
            <div style="border: 0.2px solid gray; height: 50px">
              <FourierParams :params="paramsIrregular"></FourierParams>
            </div>
          </el-col>
          <el-col :span="8">
            <div style="border: 1px solid gray">
              <CorneaParam
                :mapValues="mapValues"
                :rightsider="corneaParamAsider"
              ></CorneaParam></div
          ></el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import MapForm from "./MapForm.vue";
import CorneaParam from "./CorneaParam.vue";
import FourierParams from "./FourierParams.vue";
import FourierCalculate from "../js/FourierCalculate";
import fileSys from "../../fileoprators/fileSystem";
import { FILES } from "../shared";
import { TOPOGRAPHYEVENTS } from "../shared/events";

export default {
  name: "FourMaps",
  data() {
    return {
      corneaParamAsider: {
        isMapBoolen: false,
        isScaleBoolen: true,
        isImageBoolen: false
      },
      paramsSph: [],
      paramsDecent: [],
      paramsRegular: [],
      paramsIrregular: []
    };
  },
  created() {},
  mounted: function () {
    this.Calculate();
    this.$emit("hide-waiting");
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30
    },
    dispH: {
      type: Number,
      default: window.screen.height - 70 - 30
    },
    mapValues: {
      type: Object,
      defaultL: () => {
        return {};
      }
    },
    value: Boolean
  },
  components: {
    MapForm,
    CorneaParam,
    FourierParams
  },

  watch: {},
  computed: {},
  methods: {
    Calculate() {
      let casePath = this.$store.state.topography.casePath;
      let obj = FourierCalculate.Calculate(fileSys.combinePath(casePath, FILES.cartSagf));
      this.paramsSph = obj.value.paramsSph;
      this.paramsDecent = obj.value.paramsDecent;
      this.paramsRegular = obj.value.paramsRegular;
      this.paramsIrregular = obj.value.paramsIrregular;
      this.$bus.$emit(TOPOGRAPHYEVENTS.fourierDataChanged, obj.sph, 0);
      this.$bus.$emit(TOPOGRAPHYEVENTS.fourierDataChanged, obj.decent, 1);
      this.$bus.$emit(TOPOGRAPHYEVENTS.fourierDataChanged, obj.regular, 3);
      this.$bus.$emit(TOPOGRAPHYEVENTS.fourierDataChanged, obj.irregular, 4);
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/topography/components/FourierAnalysis.vue